import {Component, OnInit, Input, ViewChild, EventEmitter, Output} from '@angular/core';
import { Competition } from 'app/models/competition';

@Component({
  selector: 'app-competition-logo',
  templateUrl: './competition-logo.component.html',
  styleUrls: ['./competition-logo.component.scss']
})
export class CompetitionLogoComponent implements OnInit {

  @Input() competition: Competition;
  @Input() disabled: boolean;
  @Output() fileError = new EventEmitter<number>();
  @ViewChild('file') file: any;
  constructor() {
    this.disabled = false;
  }

  ngOnInit() {
  }

  onImgChange(event): void {
    this.competition.logoFile = event.file.name;
    this.competition.logoUrl = event.url;
  }

  onChange(event): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileSize = event.target.files[0].size / 1000; // in bytes
      if (fileSize >= 400) {
        this.fileError.emit(fileSize);
        return;
      }
      reader.readAsDataURL(file);
      reader.onload = (result) => {
        if (file.type.includes('image')) {
          this.competition.logoFile = file.name;
          this.competition.logoUrl = reader.result;
        }
      };
    }
  }
  cancel() {
    if (this.file) {
      this.file.nativeElement.value = '';
    }
  }

  // TODO Have to change when backend is ready
  onUpload(): void {
    console.log('upload file');
  }
}
